import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import qs from 'querystring'; // 前端存三分钟

import EasyStore from '../util/easy-store'; // client js begin

import Boss from '@tencent/vft-common/Boss';
import LJReport from '@tencent/vft-speedreport/LJReport'; // client js end

import util from './index';
var boss = new Boss({
  bossId: 6183,
  pwd: 1714812455
});
var monitor = new LJReport({
  project: 'video_vip_fe',
  page: 'cloud_seal_card'
});
var store = new EasyStore("cloud_seal_store", 'local');
var expires = 3 * 60 * 1000;
export var Report = /*#__PURE__*/function () {
  function Report(performanceReportData) {
    _classCallCheck(this, Report);

    this.performanceReportData = performanceReportData || {};
  }

  _createClass(Report, [{
    key: "setReportData",
    value: function setReportData(key, val) {
      this.performanceReportData[key] = val;
    }
  }, {
    key: "reportImgLoad",
    value: function reportImgLoad() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          tryCount = _ref.tryCount,
          cost = _ref.cost;

      var oldTryCount = this.performanceReportData['imgLoadTryCount'] || 0;
      var oldCost = this.performanceReportData['imgLoadCost'] || 0;
      this.setReportData('imgLoadTryCount', oldTryCount + tryCount);
      this.setReportData('imgLoadCost', oldCost + cost);
    }
  }, {
    key: "reportPerformance",
    value: function reportPerformance() {
      try {
        var _this$performanceRepo = this.performanceReportData,
            _this$performanceRepo2 = _this$performanceRepo.totalCost,
            totalCost = _this$performanceRepo2 === void 0 ? 0 : _this$performanceRepo2,
            _this$performanceRepo3 = _this$performanceRepo.replaceCost,
            replaceCost = _this$performanceRepo3 === void 0 ? 0 : _this$performanceRepo3,
            _this$performanceRepo4 = _this$performanceRepo.showImgCost,
            showImgCost = _this$performanceRepo4 === void 0 ? 0 : _this$performanceRepo4,
            _this$performanceRepo5 = _this$performanceRepo.fetchDataError,
            fetchDataError = _this$performanceRepo5 === void 0 ? 0 : _this$performanceRepo5,
            _this$performanceRepo6 = _this$performanceRepo.showImgError,
            showImgError = _this$performanceRepo6 === void 0 ? 0 : _this$performanceRepo6,
            _this$performanceRepo7 = _this$performanceRepo.backData,
            backData = _this$performanceRepo7 === void 0 ? 0 : _this$performanceRepo7,
            _this$performanceRepo8 = _this$performanceRepo.imgLoadError,
            imgLoadError = _this$performanceRepo8 === void 0 ? 0 : _this$performanceRepo8,
            _this$performanceRepo9 = _this$performanceRepo.picGeneratorFailHandler,
            picGeneratorFailHandler = _this$performanceRepo9 === void 0 ? 0 : _this$performanceRepo9,
            mode = _this$performanceRepo.mode,
            id = _this$performanceRepo.id,
            version = _this$performanceRepo.version;
        monitor.report({
          modId: 'card',
          metrics: _objectSpread(_objectSpread({}, this.performanceReportData), {}, {
            totalCost: totalCost,
            replaceCost: replaceCost,
            showImgCost: showImgCost,
            showImgError: showImgError,
            backData: backData,
            imgLoadError: imgLoadError,
            picGeneratorFailHandler: picGeneratorFailHandler,
            count: 1,
            error: fetchDataError || showImgError || picGeneratorFailHandler
          }),
          tags: {
            version: version,
            mode: mode,
            id: id,
            href: location.href.split('?')[0]
          }
        });
      } catch (e) {}
    }
  }, {
    key: "reportLog",
    value: function reportLog(module, log) {
      this.performanceReportData[module] = 1;
      boss.report({
        f_url: '/cloud_seal_card',
        f_resource: location.pathname,
        f_dm: location.host,
        f_module: module,
        f_ext: log,
        _dc: Math.random()
      });
    }
  }]);

  return Report;
}();
export function getCardImg(_ref2) {
  var _ref2$url = _ref2.url,
      url = _ref2$url === void 0 ? '/cgi/card/getCardImgById' : _ref2$url,
      _ref2$query = _ref2.query,
      query = _ref2$query === void 0 ? {} : _ref2$query;
  return new Promise(function (resolve, reject) {
    var timer = setTimeout(reject, 3000);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.send(qs.stringify(query));

    xhr.onreadystatechange = function (e) {
      var json = util.parseJson(xhr.responseText);

      if (xhr.readyState === 4) {
        clearTimeout(timer);

        if (xhr.status === 200) {
          resolve(json.data);
        } else {
          reject(json);
        }
      }
    };
  });
}
export function getCardData(_ref3) {
  var _ref3$url = _ref3.url,
      url = _ref3$url === void 0 ? '' : _ref3$url,
      _ref3$query = _ref3.query,
      query = _ref3$query === void 0 ? {} : _ref3$query,
      _ref3$retry = _ref3.retry,
      retry = _ref3$retry === void 0 ? 3 : _ref3$retry,
      _ref3$useCache = _ref3.useCache,
      useCache = _ref3$useCache === void 0 ? true : _ref3$useCache,
      reportInstance = _ref3.reportInstance;
  // 预览的不走缓存
  var totalTryCount = retry;
  var isPreview = query.version || query.env;

  if (!isPreview) {
    var storeData = store.get(query.id);

    if (storeData) {
      console.log('get data from cache.', storeData);
      reportInstance && reportInstance.setReportData('getCardDataReTryCount', 0); // 上报

      return Promise.resolve(storeData);
    }
  }

  return new Promise( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      var fetchData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchData = function fetchData() {
                retry -= 1;
                return util.getJSON(url + '?' + qs.stringify(query)).then(function (res) {
                  if (res.code === 0 && res.data) {
                    var cardData = res.data;
                    useCache && store.set(cardData.id, cardData, expires); // 存进去

                    reportInstance && reportInstance.setReportData('getCardDataReTryCount', totalTryCount - retry - 1); // 上报

                    return resolve(cardData);
                  }

                  return Promise.reject(res);
                }).catch(function (e) {
                  // code -2001 card not exit
                  if (retry > 0 && e.code !== -2001) {
                    return fetchData();
                  } else {
                    reportInstance && reportInstance.setReportData('getCardDataReTryCount', totalTryCount - retry - 1); // 上报

                    reject(e);
                  }
                  /** else if (backData) {
                   // 使用兜底数据
                   console.warn('【cloud-seal-card】使用兜底数据..', backData)
                   reportInstance && reportInstance.reportLog('backData', util.getVal(query, 'id'))
                   return resolve(backData)
                  } else {
                   reportInstance && reportInstance.reportLog('fetchDataError', util.getVal(query, 'id'))
                   reject(e)
                  }**/

                });
              };

              fetchData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }());
}